import type { DefaultRowModel } from '../types/default-row-model.type';

export const defaultGetRowId = <R extends DefaultRowModel>(row: R) => row._id;
